mutation CreateLanguage($input: CreateLanguageInput!) {
  createLanguage(input: $input) {
    id
  }
}
